export const JOB_CATEGORY = [
  {
    text: "技術開發",
    value: "技術開發",
  },
  {
    text: "軟體開發/MIS",
    value: "軟體開發/MIS",
  },
  {
    text: "行銷/廣告/公關",
    value: "行銷/廣告/公關",
  },
  {
    text: "業務/銷售",
    value: "業務/銷售",
  },
  {
    text: "人力資源",
    value: "人力資源",
  },
  {
    text: "專業人員",
    value: "專業人員",
  },
  {
    text: "行政/總務/客服",
    value: "行政/總務/客服",
  },
  {
    text: "生產製造/品牌/環衛",
    value: "生產製造/品牌/環衛",
  },
  {
    text: "營運/幕僚",
    value: "營運/幕僚",
  },
  {
    text: "門市營業/餐飲服務",
    value: "門市營業/餐飲服務",
  },
  {
    text: "設計/創意",
    value: "設計/創意",
  },
  {
    text: "文字/傳媒",
    value: "文字/傳媒",
  },
  {
    text: "採購/物流/倉儲",
    value: "採購/物流/倉儲",
  },
  {
    text: "產品/專案管理",
    value: "產品/專案管理",
  },
  {
    text: "財務/會計/金融專業",
    value: "財務/會計/金融專業",
  },
  {
    text: "秘書",
    value: "秘書",
  },
  {
    text: "其他",
    value: "其他",
  },
]

export const POSITION = [
  {
    text: "企業經營者/負責人",
    value: "企業經營者/負責人"
  },
  {
    text: "高階主管",
    value: "高階主管"
  },
  {
    text: "中階主管",
    value: "中階主管"
  },
  {
    text: "一般職員",
    value: "一般職員"
  },
  {
    text: "學生",
    value: "學生"
  },
  {
    text: "專業人士",
    value: "專業人士"
  },
  {
    text: "其他",
    value: "其他"
  },
]

export const COMPANY_INDUSTRY = [
  {
    text: "金融/投顧/保險",
    value: "金融/投顧/保險"
  },
  {
    text: "資通訊/網路服務",
    value: "資通訊/網路服務"
  },
  {
    text: "貿易/批發",
    value: "貿易/批發"
  },
  {
    text: "建築/營造",
    value: "建築/營造"
  },
  {
    text: "傳產製造",
    value: "傳產製造"
  },
  {
    text: "零售通路/民生服務",
    value: "零售通路/民生服務"
  },
  {
    text: "高科技製造",
    value: "高科技製造"
  },
  {
    text: "非營利組織",
    value: "非營利組織"
  },
  {
    text: "觀光旅宿/娛樂",
    value: "觀光旅宿/娛樂"
  },
  {
    text: "醫療/生技/健康",
    value: "醫療/生技/健康"
  },
  {
    text: "傳播/藝文",
    value: "傳播/藝文"
  },
  {
    text: "整合行銷/廣告公關",
    value: "整合行銷/廣告公關"
  },
  {
    text: "出版/媒體",
    value: "出版/媒體"
  },
  {
    text: "政府機關/公營事業/軍公教",
    value: "政府機關/公營事業/軍公教"
  },
  {
    text: "交通運輸/物流倉儲",
    value: "交通運輸/物流倉儲"
  },
  {
    text: "自由業",
    value: "自由業"
  },
  {
    text: "學生",
    value: "學生"
  },
  {
    text: "其他",
    value: "其他"
  }
]

export const COMPANY_SIZE = [
  {
    text: "100人以下",
    value: "100人以下"
  },
  {
    text: "101-300人",
    value: "101-300人"
  },
  {
    text: "301-500人",
    value: "301-500人"
  },
  {
    text: "501-1000人",
    value: "501-1000人"
  },
  {
    text: "1001人以上",
    value: "1001人以上"
  }
]

export const ROLE = [
  {
    text: "負責決定部門適用的解決方案/ 產品",
    value: "負責決定部門適用的解決方案/ 產品"
  },
  {
    text: "負責評估產品",
    value: "負責評估產品"
  },
  {
    text: "不直接負責，但可提供建議",
    value: "不直接負責，但可提供建議"
  },
  {
    text: "不相關",
    value: "不相關"
  }
]

export const ISSUE_INTEREST = [
  {
    text: "IT管理及效能監控",
    value: "IT管理及效能監控"
  },
  {
    text: "資訊安全",
    value: "資訊安全"
  },
  {
    text: "基礎架構網路",
    value: "基礎架構網路"
  },
  {
    text: "儲存系統",
    value: "儲存系統"
  },
  {
    text: "備份備援",
    value: "備份備援"
  },
  {
    text: "虛擬化",
    value: "虛擬化"
  },
  {
    text: "視訊監控",
    value: "視訊監控"
  },
  {
    text: "雲端服務",
    value: "雲端服務"
  },
  {
    text: "AI 大數據",
    value: "AI 大數據"
  },
  {
    text: "容器及DevOps",
    value: "容器及DevOps"
  },
  {
    text: "遠距應用",
    value: "遠距應用"
  },
  {
    text: "超融合基礎架構",
    value: "超融合基礎架構"
  },
  {
    text: "商業應用軟體",
    value: "商業應用軟體"
  },
  {
    text: "其他",
    value: "其他"
  }
]